import Image from 'core/display/Image'
import { enableTap } from 'core/handlers/TapHandler'
import { ButtonManager } from 'managers/ButtonManager'
import { KeyboardManager } from 'managers/KeyboardManager'
import { signal } from 'services/SignalsService'

export default class AutoButton {
  constructor(data) {
    this._data = data

    this.image = new Image(data)
    this.image.calculateGlow()
    this.name = data.name.split('-')[0]
    this.payload = parseInt(data.name.split('-')[1])
    this.id = `RADIO:${this.name}`
    this.state = ''
    this.createSignal()

    KeyboardManager.register({ id: this.id, payload: this.payload, tap: this.tap.bind(this) })
    enableTap(this.image, this.tap.bind(this))
    return this.image
  }

  createSignal() {
    const self = this
    if (self.name === 'loss') {
      signal.on('RADIO:loss', function () {
        self.image.images[0].visible =    self.payload !== game.models.AutoLimitModel.getIDLoss()
        self.image.images[1].visible =    self.payload === game.models.AutoLimitModel.getIDLoss()
      })
    }
    else {
      signal.on('RADIO:win', function () {
        self.image.images[0].visible =    self.payload !== game.models.AutoLimitModel.getIDWin()
        self.image.images[1].visible =    self.payload === game.models.AutoLimitModel.getIDWin()
      })
    }
  }

  tap(){
    ButtonManager.dispatch(this.id, this._data.deselect && this.payload === this.state ? '' : this.payload)
  }
}
